import AccorPlusLogoNoTagline from "@/assets/AccorPlusLogoNoTagline";

export const Logo = () => {
  return (
    <div className="mb-[1.13rem] flex justify-center pt-5 md:mb-3.5">
      <a href={process.env.NEXT_PUBLIC_ACCOR_PLUS_URL}>
        <AccorPlusLogoNoTagline className="fill-blue-dark" />
      </a>
    </div>
  );
};
